// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { BroadcastListInfoResponseDTO } from "../../api/backend-openapi";
import {
  addBroadcastList,
  deleteBroadcastList,
  setBroadcastLists,
  updateBroadcastList
} from "./BroadcastListsEvents";

export const BroadcastListsStore = createStore<BroadcastListInfoResponseDTO[]>(
  []
)
  .on<BroadcastListInfoResponseDTO[]>(
    setBroadcastLists,
    (
      state: BroadcastListInfoResponseDTO[],
      payload: BroadcastListInfoResponseDTO[]
    ) => payload
  )
  .on<string>(
    deleteBroadcastList,
    (state: BroadcastListInfoResponseDTO[], payload: string) =>
      state.filter(broadcastList => broadcastList.id !== payload)
  )
  .on<BroadcastListInfoResponseDTO>(
    addBroadcastList,
    (
      state: BroadcastListInfoResponseDTO[],
      payload: BroadcastListInfoResponseDTO
    ) => [...state, payload]
  )
  .on<BroadcastListInfoResponseDTO>(
    updateBroadcastList,
    (
      state: BroadcastListInfoResponseDTO[],
      payload: BroadcastListInfoResponseDTO
    ) => [
      ...state.filter(broadcastList => broadcastList.id !== payload.id),
      payload
    ]
  );
